import React, { useRef } from 'react';
import styled from 'styled-components';
import { FdrMapProvider } from '@hotelplan/fdr.regular.fusion.fdr-map';
import { useScrollElement } from '@hotelplan/libs.context.ios-scroll-block';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import {
  fdrMapContainerStyles,
  fdrMapFormWrapperStyles,
  fdrMapCardsContainerStyles,
} from 'fdr/components/local/fdr-map/fdr-map.styles';
import useFdrMapForm from 'fdr/components/local/fdr-map/fdr-use-map-form';
import FdrWishlistMap from './fdr-wishlist-map';
import FdrWishlistMapResults from './fdr-wishlist-map-results';

const WishlistMapFormWrapper = styled.div(
  { display: 'flex' },
  fdrMapFormWrapperStyles
);

const WishlistMapContainerWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    px: [0, '15px'],
    '.map-container': fdrMapContainerStyles,
    '.map-cards': fdrMapCardsContainerStyles,
  })
);

const FdrWishlistMapForm: React.FC = () => {
  const {
    mapContainerRef,
    mapProviderProps,
    selectedObjects,
    onSelectObjects,
    deselect,
  } = useFdrMapForm();

  const wishlistMapCardsContainerEl = useRef<HTMLDivElement>(null);

  useScrollElement(wishlistMapCardsContainerEl, true);

  return (
    <WishlistMapFormWrapper data-id="map-form-wrapper">
      <WishlistMapContainerWrapper data-id="map-container-wrapper">
        <div
          data-id="mapContainer"
          ref={mapContainerRef}
          className="map-container"
        >
          <FdrMapProvider {...mapProviderProps}>
            <FdrWishlistMap
              onSelect={onSelectObjects}
              onClickOnSelectedPin={deselect}
            />
          </FdrMapProvider>
        </div>
        <div
          data-id="map-cards"
          ref={wishlistMapCardsContainerEl}
          className="map-cards"
        >
          <FdrWishlistMapResults
            items={selectedObjects
              ?.filter(o => o?.product?.id)
              .map(o => ({ id: o.product.id }))}
            onClose={deselect}
          />
        </div>
      </WishlistMapContainerWrapper>
    </WishlistMapFormWrapper>
  );
};

export default FdrWishlistMapForm;
